import cf from './cf';
import i15v_20211024 from './i15v_20211024';

export default class i15v1a extends i15v_20211024 {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
//    this.class = this.constructor.name;
    this.class = 'i15v1a';
    this.d_viewDefs = {
      name: '団体種別'
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
